<ndt-extension-group-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [accountId]="accountId | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [extensionGroupPrivileges]="extensionGroupPrivileges$ | async"
   (create)="onCreate()"
   [name]="entityName"
   [columns]="columns"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
>
</ndt-extension-group-register-view>
